var _desc, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFileMp4Bw(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 63,
    viewBox: "0 0 50 63",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created using Figma")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "file-mp4-bw_svg__file-mp4-bw_svg__Canvas",
    transform: "translate(10724 -935)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-mp4-bw_svg__file-mp4-bw_svg__file-mp4-bw"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-mp4-bw_svg__file-mp4-bw_svg__Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-mp4-bw_svg__file-mp4-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-mp4-bw_svg__file-mp4-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#file-mp4-bw_svg__file-mp4-bw_svg__path0_fill",
    transform: "matrix(1 0 0 -1 -10713 966.368)",
    fill: "#FFFFFF"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "file-mp4-bw_svg__file-mp4-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-mp4-bw_svg__file-mp4-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#file-mp4-bw_svg__file-mp4-bw_svg__path1_fill",
    transform: "matrix(1 0 0 -1 -10708.5 974.665)",
    fill: "#FFFFFF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "file-mp4-bw_svg__file-mp4-bw_svg__mask0_alpha",
    "mask-type": "alpha"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-mp4-bw_svg__file-mp4-bw_svg__mask0_outline_ins"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-mp4-bw_svg__file-mp4-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#file-mp4-bw_svg__file-mp4-bw_svg__path1_fill",
    transform: "matrix(1 0 0 -1 -10708.5 974.665)",
    fill: "#FFFFFF"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "file-mp4-bw_svg__file-mp4-bw_svg__Group",
    mask: "url(#file-mp4-bw_svg__file-mp4-bw_svg__mask0_alpha)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-mp4-bw_svg__file-mp4-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#file-mp4-bw_svg__file-mp4-bw_svg__path2_fill",
    transform: "matrix(1 0 0 -1 -10709.3 975.527)",
    fill: "#4F4F4F"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "file-mp4-bw_svg__file-mp4-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-mp4-bw_svg__file-mp4-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#file-mp4-bw_svg__file-mp4-bw_svg__path3_fill",
    transform: "matrix(1 0 0 -1 -10705.7 972.009)",
    fill: "#4F4F4F"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "file-mp4-bw_svg__file-mp4-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-mp4-bw_svg__file-mp4-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#file-mp4-bw_svg__file-mp4-bw_svg__path3_fill",
    transform: "matrix(1 0 0 -1 -10705.7 968.854)",
    fill: "#4F4F4F"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "file-mp4-bw_svg__file-mp4-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-mp4-bw_svg__file-mp4-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#file-mp4-bw_svg__file-mp4-bw_svg__path3_fill",
    transform: "matrix(1 0 0 -1 -10705.7 965.728)",
    fill: "#4F4F4F"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "file-mp4-bw_svg__file-mp4-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-mp4-bw_svg__file-mp4-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#file-mp4-bw_svg__file-mp4-bw_svg__path4_fill",
    transform: "matrix(1 0 0 -1 -10705.7 962.572)",
    fill: "#4F4F4F"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "file-mp4-bw_svg__file-mp4-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-mp4-bw_svg__file-mp4-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#file-mp4-bw_svg__file-mp4-bw_svg__path5_fill",
    transform: "matrix(1 0 0 -1 -10693.4 972.009)",
    fill: "#4F4F4F"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "file-mp4-bw_svg__file-mp4-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-mp4-bw_svg__file-mp4-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#file-mp4-bw_svg__file-mp4-bw_svg__path5_fill",
    transform: "matrix(1 0 0 -1 -10693.4 968.854)",
    fill: "#4F4F4F"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "file-mp4-bw_svg__file-mp4-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-mp4-bw_svg__file-mp4-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#file-mp4-bw_svg__file-mp4-bw_svg__path5_fill",
    transform: "matrix(1 0 0 -1 -10693.4 965.728)",
    fill: "#4F4F4F"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "file-mp4-bw_svg__file-mp4-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-mp4-bw_svg__file-mp4-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#file-mp4-bw_svg__file-mp4-bw_svg__path6_fill",
    transform: "matrix(1 0 0 -1 -10693.4 962.572)",
    fill: "#4F4F4F"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "file-mp4-bw_svg__file-mp4-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-mp4-bw_svg__file-mp4-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#file-mp4-bw_svg__file-mp4-bw_svg__path4_fill",
    transform: "matrix(1 0 0 -1 -10705.7 959.553)",
    fill: "#4F4F4F"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "file-mp4-bw_svg__file-mp4-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-mp4-bw_svg__file-mp4-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#file-mp4-bw_svg__file-mp4-bw_svg__path6_fill",
    transform: "matrix(1 0 0 -1 -10693.4 959.553)",
    fill: "#4F4F4F"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "file-mp4-bw_svg__file-mp4-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-mp4-bw_svg__file-mp4-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#file-mp4-bw_svg__file-mp4-bw_svg__path7_fill",
    transform: "matrix(1 0 0 -1 -10701.2 968.189)",
    fill: "#4F4F4F"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "file-mp4-bw_svg__file-mp4-bw_svg__file-mp4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-mp4-bw_svg__file-mp4-bw_svg__Canvas"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-mp4-bw_svg__file-mp4-bw_svg__Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-mp4-bw_svg__file-mp4-bw_svg__Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-mp4-bw_svg__file-mp4-bw_svg__Group_5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-mp4-bw_svg__file-mp4-bw_svg__Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-mp4-bw_svg__file-mp4-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-mp4-bw_svg__file-mp4-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#file-mp4-bw_svg__file-mp4-bw_svg__path8_fill",
    transform: "translate(-10724 935)",
    fill: "#D9DEE0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "file-mp4-bw_svg__file-mp4-bw_svg__Burger_Angus_Burger"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-mp4-bw_svg__file-mp4-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#file-mp4-bw_svg__file-mp4-bw_svg__path9_fill",
    transform: "translate(-10709.7 979.119)",
    fill: "#FFFFFF"
  })))))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "file-mp4-bw_svg__file-mp4-bw_svg__path0_fill",
    d: "M 2.00509 0.771819L 5.80639 0L 17.8304 9.4341L 18.1269 10.2382C 18.3157 10.8901 18.2078 11.5942 17.8304 12.168C 17.4799 12.7417 16.8868 13.1589 16.2128 13.3154L 5.80639 15.7667C 5.61769 15.8189 5.40202 15.845 5.18635 15.845C 4.70107 15.845 4.24276 15.7146 3.81139 15.4799C 3.21828 15.1409 2.78692 14.5672 2.62517 13.9152L 0.0909576 3.84904C -0.0977599 3.19709 0.0100785 2.49298 0.387514 1.91926C 0.73799 1.34554 1.3311 0.92829 2.00509 0.771819Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "file-mp4-bw_svg__file-mp4-bw_svg__path1_fill",
    d: "M 2.97151 0L 16.6405 0C 18.267 0 19.612 1.31411 19.612 2.97238L 19.612 16.6453C 19.612 18.2723 18.2983 19.6177 16.6405 19.6177L 2.97151 19.6177C 1.345 19.6177 0 18.3036 0 16.6453L 0 2.97238C 0 1.3454 1.31372 0 2.97151 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "file-mp4-bw_svg__file-mp4-bw_svg__path2_fill",
    d: "M 17.5026 -2.61531e-09L 3.8337 -2.61531e-09L 3.8337 1.72439L 17.5026 1.72439L 17.5026 -2.61531e-09ZM 3.8337 -2.61531e-09C 1.6936 -2.61531e-09 -2.61531e-09 1.73757 -2.61531e-09 3.83458L 1.72439 3.83458C 1.72439 2.6776 2.65823 1.72439 3.8337 1.72439L 3.8337 -2.61531e-09ZM -2.61531e-09 3.83458L -2.61531e-09 17.5075L 1.72439 17.5075L 1.72439 3.83458L -2.61531e-09 3.83458ZM -2.61531e-09 17.5075C -2.61531e-09 19.6477 1.7367 21.3421 3.8337 21.3421L 3.8337 19.6177C 2.67769 19.6177 1.72439 18.684 1.72439 17.5075L -2.61531e-09 17.5075ZM 3.8337 21.3421L 17.5026 21.3421L 17.5026 19.6177L 3.8337 19.6177L 3.8337 21.3421ZM 17.5026 21.3421C 19.6428 21.3421 21.3364 19.6046 21.3364 17.5075L 19.612 17.5075C 19.612 18.6645 18.6781 19.6177 17.5026 19.6177L 17.5026 21.3421ZM 21.3364 17.5075L 21.3364 3.83458L 19.612 3.83458L 19.612 17.5075L 21.3364 17.5075ZM 21.3364 3.83458C 21.3364 1.69446 19.5997 -2.61531e-09 17.5026 -2.61531e-09L 17.5026 1.72439C 18.6587 1.72439 19.612 2.65814 19.612 3.83458L 21.3364 3.83458Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "file-mp4-bw_svg__file-mp4-bw_svg__path3_fill",
    d: "M 1.5367 0L 0 0L 0 1.48645L 1.5367 1.48645L 1.5367 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "file-mp4-bw_svg__file-mp4-bw_svg__path4_fill",
    d: "M 1.5367 0L 0 0L 0 1.48646L 1.5367 1.48646L 1.5367 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "file-mp4-bw_svg__file-mp4-bw_svg__path5_fill",
    d: "M 1.5367 0L -4.45403e-14 0L -4.45403e-14 1.48645L 1.5367 1.48645L 1.5367 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "file-mp4-bw_svg__file-mp4-bw_svg__path6_fill",
    d: "M 1.5367 0L -4.45403e-14 0L -4.45403e-14 1.48646L 1.5367 1.48646L 1.5367 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "file-mp4-bw_svg__file-mp4-bw_svg__path7_fill",
    d: "M 0.296556 6.58474C 0.242636 6.58474 0.188717 6.58474 0.161758 6.55864C 0.0539188 6.50652 -6.34803e-15 6.40219 -6.34803e-15 6.29787L -6.34803e-15 0.299899C -6.34803e-15 0.195586 0.0539188 0.0912734 0.161758 0.0391173C 0.269596 -0.0130391 0.377435 -0.0130391 0.458315 0.0391173L 5.49978 3.03811C 5.58064 3.09026 5.63458 3.19457 5.63458 3.29889C 5.63458 3.4032 5.58064 3.48144 5.49978 3.55967L 0.458315 6.53258C 0.404395 6.55864 0.350475 6.58474 0.296556 6.58474Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "file-mp4-bw_svg__file-mp4-bw_svg__path8_fill",
    d: "M 35.7147 0L 3.57076 0C 1.60081 0 7.27601e-17 1.55148 7.27601e-17 3.47066L 7.27601e-17 58.6161C 7.27601e-17 60.5333 1.60081 62.087 3.57076 62.087L 46.4292 62.087C 48.4033 62.087 50 60.5333 50 58.6161L 50 13.8826L 35.7147 0ZM 35.7147 4.90695L 44.951 13.8826L 35.7147 13.8826L 35.7147 4.90695ZM 46.4296 58.6161L 3.57076 58.6161L 3.57076 3.47066L 32.1432 3.47066L 32.1432 13.8826C 32.1432 15.7997 33.7404 17.3533 35.7139 17.3533L 46.4292 17.3533L 46.4292 58.6161L 46.4296 58.6161Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "file-mp4-bw_svg__file-mp4-bw_svg__path9_fill",
    d: "M 7.55279 4.6792e-08C 7.70453 4.6792e-08 7.83215 0.051733 7.9356 0.155195C 8.03906 0.258657 8.09081 0.386263 8.09081 0.538009L 8.09081 7.54244C 8.09081 7.69422 8.03563 7.82179 7.92528 7.92525C 7.82178 8.02871 7.69763 8.08046 7.55279 8.08046C 7.40105 8.08046 7.27343 8.02871 7.16998 7.92525C 7.06652 7.82179 7.01477 7.69422 7.01477 7.54244L 7.01477 2.40034L 4.51097 7.50105C 4.39372 7.68042 4.23855 7.77008 4.04539 7.77008C 3.81778 7.77008 3.65225 7.66316 3.54879 7.44935L 1.07601 2.49346L 1.07601 7.54244C 1.07601 7.69422 1.0243 7.82179 0.920802 7.92525C 0.817344 8.02871 0.689767 8.08046 0.537988 8.08046C 0.38625 8.08046 0.258673 8.02871 0.155174 7.92525C 0.0517288 7.82179 -8.36899e-08 7.69422 -8.36899e-08 7.54244L -8.36899e-08 0.538009C -8.36899e-08 0.386263 0.0517288 0.258657 0.155174 0.155195C 0.258673 0.051733 0.38625 4.6792e-08 0.537988 4.6792e-08C 0.744945 4.6792e-08 0.90358 0.0965646 1.01393 0.289698L 4.08677 6.44574L 7.07689 0.289698C 7.18724 0.0965646 7.34587 4.6792e-08 7.55279 4.6792e-08ZM 10.7024 8.08046C 10.5507 8.08046 10.4231 8.02871 10.3196 7.92525C 10.2162 7.82179 10.1644 7.69422 10.1644 7.54244L 10.1644 0.538009C 10.1644 0.379366 10.2162 0.251759 10.3196 0.155195C 10.4231 0.051733 10.5507 4.6792e-08 10.7024 4.6792e-08L 12.7717 4.6792e-08C 13.2821 4.6792e-08 13.7373 0.113808 14.1374 0.341427C 14.5443 0.569046 14.8582 0.886333 15.0789 1.29329C 15.3065 1.70024 15.4204 2.16238 15.4204 2.67969C 15.4204 3.18321 15.3065 3.63153 15.0789 4.02471C 14.8582 4.41785 14.5443 4.72479 14.1374 4.94555C 13.7373 5.16626 13.2821 5.27661 12.7717 5.27661L 11.2404 5.27661L 11.2404 7.54244C 11.2404 7.69422 11.1887 7.82179 11.0853 7.92525C 10.9887 8.02871 10.8611 8.08046 10.7024 8.08046ZM 12.7717 4.28338C 13.2407 4.28338 13.627 4.13507 13.9305 3.83849C 14.234 3.53497 14.3857 3.14873 14.3857 2.67969C 14.3857 2.18997 14.234 1.78646 13.9305 1.46917C 13.627 1.15189 13.2407 0.993243 12.7717 0.993243L 11.2404 0.993243L 11.2404 4.28338L 12.7717 4.28338ZM 21.3906 5.2973C 21.5493 5.2973 21.6769 5.33526 21.7735 5.41113C 21.87 5.48699 21.9183 5.60768 21.9183 5.77325C 21.9183 5.90429 21.8666 6.01808 21.7631 6.11468C 21.6596 6.20434 21.5355 6.24915 21.3906 6.24915L 20.7698 6.24915L 20.7698 7.5528C 20.7698 7.69764 20.7181 7.82179 20.6147 7.92525C 20.5181 8.02871 20.3974 8.08046 20.2526 8.08046C 20.1146 8.08046 19.9973 8.02871 19.9008 7.92525C 19.8042 7.82179 19.7559 7.69764 19.7559 7.5528L 19.7559 6.24915L 16.3106 6.24915C 16.152 6.24915 16.0244 6.19745 15.9278 6.09399C 15.8312 5.99049 15.7829 5.86981 15.7829 5.73187C 15.7829 5.61457 15.8174 5.51111 15.8864 5.42145L 19.8491 0.227619C 19.9663 0.0758731 20.1111 4.6792e-08 20.2836 4.6792e-08C 20.4284 4.6792e-08 20.5457 0.051733 20.6354 0.155195C 20.725 0.258657 20.7698 0.386263 20.7698 0.538009L 20.7698 5.2973L 21.3906 5.2973ZM 17.1487 5.2973L 19.7559 5.2973L 19.7559 1.87268L 17.1487 5.2973Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileMp4Bw);
export default __webpack_public_path__ + "static/media/file-mp4-bw.dc70a4296a9ade9a3328ee90ba05a75f.svg";
export { ForwardRef as ReactComponent };